import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import preview2 from '../../assets/Evaluation.jpg'
import preview4 from '../../assets/live.jpg'
import preview1 from '../../assets/Live2.jpg'
import preview3 from '../../assets/Screenshot-2.png'
import LayoutCol from '../../components/Layout/LayoutCol'
import UIHighlightedTitle from '../../components/UI/UIHighlightedTitle'
import { COLOR_GREEN__PALE, COLOR_WHITE } from '../../lib/colors'
import { leToBr } from '../../utils/Utils'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    backgroundColor: 'rgb(230,126,117,255)',
    background:
      'linear-gradient(45deg, rgba(254,208,11,1) 0%, rgba(230,126,117,1) 50%, rgba(211,0,115,1) 100%)',
    fontWeight: 700,
    color: COLOR_WHITE,
    letterSpacing: '-0.05em',
    padding: '6em 6em',
    '@media (max-width: 480px)': {
      margin: '0',
      padding: '80px 20px 40px 20px',
    },
  },
  containerTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '3em',
    '@media (max-width: 1024px)': {
      position: 'relative',
      flexDirection: 'column',
      left: '0',
      alignItems: 'flex-start',
    },
  },
  containerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    '@media (max-width: 480px)': {
      width: 'auto',
      flexWrap: 'nowrap',
      gap: '10vw',
      padding: '0 10% 10% 10%',
    },
  },
  title: {
    margin: '0em 0.3em 0em 0em',
    fontSize: '3em',
    '@media (max-width: 480px)': {
      fontSize: '2em',
    },
  },
  containerPreview: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '15em',
  },
  titlePreview: {
    margin: '1em 0em 0.2em 0em',
    fontSize: '2.5em',
  },
  imagePreview: {
    width: '100%',
    objectFit: 'cover',
    borderRadius: '15px',
  },
  description: {
    fontWeight: 400,
    margin: 0,
    lineHeight: '1.5em',
  },
  col: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '30px',
  },
  content: {
    width: '80vw',
  },
  highlighted: {
    margin: '0px',
    fontSize: '3em',
    '@media (max-width: 480px)': {
      margin: '10px 0 0 0',
      fontSize: '2em',
      textAlign: 'left',
    },
  },
})

const AppPreview = () => {
  const { t } = useTranslation('translation')

  const listPreview = [
    {
      image: preview4,
      title: t('pages.beAMaker.titleOne'),
      description: t('pages.beAMaker.descriptionOne'),
    },
    {
      image: preview3,
      title: t('pages.beAMaker.titleTwo'),
      description: t('pages.beAMaker.descriptionTwo'),
    },
    {
      image: preview1,
      title: leToBr(t('pages.beAMaker.titleThree')),
      description: leToBr(t('pages.beAMaker.descriptionThree')),
    },
    {
      image: preview2,
      title: leToBr(t('pages.beAMaker.titleFour')),
      description: t('pages.beAMaker.descriptionFour'),
    },
  ]

  return (
    <>
      <div id="app-preview" className={css(styles.container)}>
        <div className={css(styles.containerTitle)}>
          <p className={css(styles.title)}>
            {t('pages.beAMaker.titlePreview')}
          </p>
          <UIHighlightedTitle
            value={t('pages.beAMaker.application')}
            backgroundColor={COLOR_GREEN__PALE}
            dynamicStyle={styles.highlighted}
          />
        </div>
        <div className={css(styles.containerContent)}>
          {listPreview.map(({ image, title, description }, index) =>
            window.innerWidth < 900 ? (
              <div className={css(styles.content)}>
                <Preview
                  key={index}
                  imagePreview={image}
                  title={title}
                  description={description}
                  dynamicStyle={styles.content}
                />
              </div>
            ) : (
              <LayoutCol dynamicStyle={styles.col} key={index} lg={3} col={6}>
                <Preview
                  key={index}
                  imagePreview={image}
                  title={title}
                  description={description}
                />
              </LayoutCol>
            )
          )}
        </div>
      </div>
    </>
  )
}

const Preview = ({ imagePreview, title, description, dynamicStyle }) => {
  return (
    <>
      <div className={css(styles.containerPreview, dynamicStyle)}>
        <img
          className={css(styles.imagePreview)}
          src={imagePreview}
          alt="screenshoot application"
          width="100%"
          height="auto"
        />
        <h1 className={css(styles.titlePreview)}>{title}</h1>
        <p className={css(styles.description)}>{description}</p>
      </div>
    </>
  )
}

Preview.propTypes = {
  imagePreview: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  dynamicStyle: PropTypes.object,
}

export default AppPreview
